import React from "react";
import { Button, Icon } from "@scuf/common";
import "./ReviewButton.scss";
import SummaryStatistics from "./SummaryStatistics";
import {REVIEW_IMMIDIATELY_TEXT} from "../../constants/constants";
import { getMessage } from '../../message/utils';

interface IReviewButton {
  showSummaryStatistics: boolean;
  toggleSummaryStatistics: Function;
  addExtraWidth?: boolean
}

const ReviewButton = (props: IReviewButton) => {
  const quickSummary: string = getMessage('app.tab.dropdown.quicksummary');
  return (
    <div style={{position:"relative"}}>
      <div
        className={`review_immediately ${
          props.showSummaryStatistics ? "pressed" : "unpressed"
        } ${props.addExtraWidth ? 'extra-margin' : ''} summary_allign`}
      >
        <Button
          iconPosition="right"
          className="custom-btn"
          type="secondary"
          icon={
            <Icon
              root="common"
              name={`caret-${props.showSummaryStatistics ? "up" : "down"}`}
              exactSize={12}
              style={{color:"#005EAC"}}
            />
          }
          content={quickSummary}
          size="small"
          textTransform={false}
          onClick={() =>
            props.toggleSummaryStatistics(!props.showSummaryStatistics)
          }
        />
      </div>
      {props.showSummaryStatistics && (
        <div style={{ position: "relative" }}>
          <SummaryStatistics
            isLandingPage={false}
            hideSummaryStatistics={() => props.toggleSummaryStatistics(false)}
            addExtraWidth={props.addExtraWidth}
          />
        </div>
      )}
    </div>
  );
};

export default ReviewButton;
